import { Component, h } from 'preact'
import { FilterSelectorComponent, FilterSelectorState } from './interfaces'
import InputGroup from '../../ui-components/InputGroup'

class RadioInputFilterSelector extends Component<FilterSelectorComponent, FilterSelectorState> {
  constructor (props: FilterSelectorComponent) {
    super(props)
    this.state = {
      condition: props.selectedFilterItems?.condition || '',
      data: typeof props.selectedFilterItems.data !== 'undefined' ? Number(props.selectedFilterItems.data) : ''
    }
  }

  setCondition = (condition: string) => {
    const { data } = this.state
    this.setState({ condition, data })
  }

  setData = (data: string) => {
    const { condition } = this.state
    this.setState({ condition, data })
  }

  render ({ id, name, items, selectedFilterItems, children } : FilterSelectorComponent, { condition, data }: FilterSelectorState) {
    return <div>
      <div className='overview__filters-box-content'>
        {items.map(item => {
          const checked = condition === item.value
          return <div>
            <InputGroup
              inline
              key={item.id}
              name={name}
              value={item.value}
              title={item.name}
              type='radio'
              formGroupClasses='overview__filters-box-filter'
              checked={checked}
              onChange={(e) => this.setCondition(e.target.value)} />
            { checked &&
              <InputGroup
                inline
                name={name}
                value={data}
                title={id}
                type='number'
                min={0}
                formGroupClasses='overview__filters-data-input'
                onKeyUp={(e) => this.setData(e.target.value)}
                onChange={(e) => this.setData(e.target.value)}
              /> }
          </div>
        })}
      </div>
      { children[0]({
        data: { ...this.state, data: Number(data) },
        isApplyButtonDisabled: !condition || data === '' }) }
    </div>
  }
}

export default RadioInputFilterSelector
